export default __webpack_public_path__ + "static/media/joysrus.e52d079b.jpg";